import { useSaveUserSecurityAnswerMutation } from "../../../../../../api/user/useSaveUserSecurityAnswerMutation";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../../utilities/api";

const MESSAGE = {
  invalid_password_or_user_not_found:
    "The password you entered is incorrect. Please try again.",
  __fallback:
    "Unable to update security question answer. Please try again later.",
};

export function useSubmit() {
  const { mutateAsync, isLoading } = useSaveUserSecurityAnswerMutation({
    onSuccess: () => {
      uiNotification.success(
        "Security question answer has been successfully updated",
      );
    },
    onError: (res) => {
      const message = extractApiError(res);
      uiNotification.error(MESSAGE[message] || MESSAGE.__fallback);
    },
  });

  return {
    initiate: ({ questionId, answer, password }) =>
      mutateAsync({
        password,
        answer,
        question_id: questionId,
      }),
    isLoading,
  };
}
